import auditTrail from './auditTrailReducer';

export { auditTrail };
